import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetHardwareByHwId = function () {
    return useApiCall(function (signal, hwId) { return api.hardware.apiHardwareDataGetByHwIdHwIdGet(hwId, { signal: signal }); }, null, true, []);
};
